<template>
  <div class="marginBT">
    <div class="marginLR center titlesContainer">
      <h2 class="titles">{{ this.$t("datos.deudaTitulo") }}</h2>
    </div>
    <div class="shadow-5 whitePanel">
      <div>
        <Errors
          v-if="this.errors && this.errors.length > 0"
          :errors="this.errors"
        />

        <p class="bigBlueText">
          {{ this.$t("datos.textos.deudaSubtituloGrande") }}
        </p>
        <p class="greyText">
          {{ this.$t("datos.textos.deudaSubtituloPeque") }}
        </p>

        <DataTable
          :value="datosDeuda.impagos"
          class="p-datatable-responsive-demo center"
          :rowClass="rowClass"
          v-if="datosDeuda.impagos.length > 0"
        >
          <Column field="deuda" :header="this.$t('datos.header.deuda')">
            <template #body="slotProps" headerClass="grey">
              <span class="column-title">{{
                $t("datos.template.deuda")
              }}</span>
              {{ $t("datos.template.deuda") }} {{ slotProps.index + 1 }}
            </template>
          </Column>
          <Column
            field="fechaDeuda"
            :header="this.$t('datos.header.fechaDeuda')"
          >
            <template #body="slotProps">
              <span class="column-title">{{
                $t("datos.template.fechaDeuda")
              }}</span>
              {{
                new Date(slotProps.data.fechaVencimiento).toLocaleDateString()
              }}
            </template>
          </Column>
          <Column
            field="importeOriginal"
            :header="this.$t('datos.header.importeOriginal')"
          >
            <template #body="slotProps">
              <span class="column-title"
                >{{ $t("datos.template.importeOriginal") }}l</span
              >
              {{ parseFloat(slotProps.data.importe).toFixed(2) }} €
            </template>
          </Column>
          <Column
            field="pagosRealizados"
            :header="this.$t('datos.header.pagosRealizados')"
          >
            <template #body="slotProps">
              <span class="column-title">{{
                $t("datos.template.pagosRealizados")
              }}</span>
              {{ getPagosRealizados(slotProps.data.pagos).toFixed(2) }} €
            </template>
          </Column>
          <Column
            field="importePendiente"
            :header="this.$t('datos.header.importePendiente')"
          >
            <template #body="slotProps">
              <span class="column-title">{{
                $t("datos.template.importePendiente")
              }}</span>
              {{
                getImportePendiente(
                  slotProps.data.importe,
                  slotProps.data.pagos
                )
              }}
              €
            </template>
          </Column>
          <Column
            field="acciones"
            :header="this.$t('datos.header.acciones')"
            class="center"
          >
            <template #body="slotProps" class="center">
              <span class="column-title">{{
                $t("datos.template.acciones")
              }}</span>
              <i
                @click="editDebt(slotProps.data)"
                class="pi pi-pencil iconSize marginLR cursorPointer"
                v-if="!showAddDeuda"
              />
              <i
                @click="
                  [
                    removeArrayElement(datosDeuda.impagos, slotProps.data),
                    clearNuevaDeuda(),
                  ]
                "
                class="pi pi-trash iconSize marginLR cursorPointer"
              />
            </template>
          </Column>
        </DataTable>

        <div class="bluePanel" v-if="showAddDeuda || showEditDeuda">
          <div class="marginBTdecreased">
            <p class="bigBlackText">
              <b
                >{{ this.$t("datos.deuda") }}
                {{
                  showAddDeuda
                    ? datosDeuda.impagos.length + 1
                    : datosDeuda.impagos.indexOf(selectedDebt) + 1
                }}</b
              >
            </p>
          </div>

          <div class="grid">
            <div class="col-12 md:col-6">
              <p class="smallGreyText marginB5Px">
                {{ this.$t("datos.label.fechaDeuda") }}
              </p>
              <InputText
                class="inputSmall"
                id="fechaDeuda"
                type="date"
                v-model="selectedDebt.fechaVencimiento"
                :placeholder="this.$t('datos.placeholders.fechaDeuda')"
              />
            </div>
            <div class="col-12 md:col-6">
              <p class="smallGreyText marginB5Px">
                {{ this.$t("datos.label.importeDeuda") }}
              </p>
              <InputText
                class="inputSmall"
                id="importeDeuda"
                type="number"
                step=".01"
                v-model="selectedDebt.importe"
                :placeholder="this.$t('datos.placeholders.importeDeuda')"
              />
            </div>
          </div>
          <div
            class="grid"
            v-for="(pago, idx) in selectedDebt.pagos"
            :key="idx"
          >
            <div class="col-12 md:col-6">
              <p class="smallGreyText marginB5Px">
                {{ $t("datos.label.fechaPago") }}
              </p>
              <InputText
                class="inputSmall"
                id="fechaPagoRealizado"
                type="date"
                v-model="pago.fecha"
                :placeholder="$t('datos.placeholders.fechaPago')"
              />
            </div>
            <div class="col-10 md:col-5">
              <p class="smallGreyText marginB5Px">
                {{ $t("datos.label.importePago") }}
              </p>
              <InputText
                :class="`inputSmall ${
                  selectedDebtNegativa === true && 'p-invalid'
                }`"
                id="importePagoRealizado"
                type="number"
                step=".01"
                v-model="pago.importe"
                :placeholder="$t('datos.placeholders.importePago')"
              />
            </div>
            <div class="col-2 md:col-1 cursorPointer">
              <i
                class="pi pi-trash iconSize marginLR ajusteNoP rightAlign"
                @click="removeArrayElement(selectedDebt.pagos, pago)"
              />
            </div>
          </div>

          <div class="grid">
            <div class="col-12 lg:col-8 sm:col-12 left cursorPointer">
              <p class="smallBlueText">
                <i class="pi pi-exclamation-circle"></i>
                {{ this.$t("datos.label.preguntaPago") }}
                <a class="smallBlueText" @click="addNewPayment()"
                  >{{ this.$t("datos.textos.pinchaPago") }}
                </a>
              </p>
            </div>
            <div class="col-12 lg:col-4 sm:col-12 paddingTop10Px">
              <Button
                :label="this.$t('common.buttons.cancel')"
                @click="handleCancelDebt"
                class="cancelButton"
              />
              <Button
                :disabled="isAcceptDebtButtonDisabled()"
                :label="this.$t('common.buttons.accept')"
                @click="handleAcceptDebt"
                class="acceptButton rightAlign"
              />
            </div>
          </div>
        </div>

        <div
          class="centerDashedBlueSquare cursorPointer"
          @click="
            showAddDeuda = true;
            clearNuevaDeuda();
          "
          v-if="!showAddDeuda"
        >
          <p class="blueText">
            {{ this.$t("datos.textos.desplegableImporteFecha") }}
          </p>
        </div>

        <div class="grid blueSum" v-if="datosDeuda.impagos.length > 0">
          <div class="col-5">
            <b class="mediumWhiteText verticalAlignBottom">{{
              this.$t("datos.label.totalReclamado")
            }}</b>
          </div>
          <div class="col-1 col-offset-6">
            <b class="bigWhiteText verticalAlignBottom"
              >{{ totalReclamado }} €</b
            >
          </div>
        </div>

        <div v-if="errorDeudaExpirada5Anios || errorDeudaExpirada10Anios">
          <small v-if="errorDeudaExpirada5Anios" class="p-invalid"
            ><i class="pi pi-info-circle" />{{
              this.$t("datos.messages.error.deudaExpirada5Anios")
            }}</small
          >
          <small v-if="errorDeudaExpirada10Anios" class="p-invalid"
            ><i class="pi pi-info-circle" />{{
              this.$t("datos.messages.error.deudaExpirada10Anios")
            }}</small
          >
        </div>
      </div>
    </div>

    <div class="whitePanel">
      <div class="marginBottom">
        <p class="bigBlueText">{{ this.$t("datos.label.preguntaDeuda") }}</p>
        <Dropdown
          v-model="datosDeuda.origen"
          :class="`input ${validation.debtOrigin === false && 'p-invalid'}`"
          :options="origenesDeuda"
          optionLabel="valor"
          optionValue="clave"
          :placeholder="this.$t('datos.placeholders.origen')"
        />
        <small v-if="validation.debtOrigin === false" class="p-invalid">{{
          this.$t("datos.messages.error.campoIncorrecto")
        }}</small>
      </div>

      <div class="marginBottom">
        <p class="bigBlueText">
          {{ this.$t("datos.label.preguntaViaJudicial") }}
        </p>
        <div class="box">
          <div class="field-radiobutton paddingBottom10Px">
            <RadioButton
              v-model="datosDeuda.demanda"
              inputId="noAccionLegal"
              name="actividadAutonomo"
              value="noAccionLegal"
            />
            <label for="profesional" class="text">
              {{ this.$t("datos.label.emprenderAccionLegal") }}
            </label>
          </div>
          <div class="field-radiobutton paddingBottom10Px">
            <RadioButton
              v-model="datosDeuda.demanda"
              inputId="siAccionLegalFavorable"
              name="actividadAutonomo"
              value="siAccionLegalFavorable"
            />
            <label for="profesional" class="text">
              {{ this.$t("datos.label.procesoJudicialFavorable") }}
            </label>
          </div>
          <div class="field-radiobutton paddingBottom10Px">
            <RadioButton
              v-model="datosDeuda.demanda"
              inputId="siAccionLegalDesfavorable"
              name="actividadAutonomo"
              value="siAccionLegalDesfavorable"
            />
            <label for="privada" class="text">
              {{ this.$t("datos.label.procesoJudicialDesfavorable") }}
            </label>
          </div>
          <small v-if="validation.lawsuit === false" class="p-invalid">{{
            this.$t("datos.messages.error.campoIncorrecto")
          }}</small>
        </div>
      </div>
      <div class="marginBottom">
        <p class="bigBlueText">
          {{ this.$t("datos.textos.documentacionAcreditacionTitulo") }}
        </p>
        <p
          v-html="this.$t('datos.textos.documentacionAcreditacion')"
          class="text"
        ></p>
        <p
          v-html="this.$t('datos.textos.documentacionAcreditacion2')"
          class="text"
        ></p>
        <p
          v-html="
            this.$t('datos.textos.documentacionAcreditacionMaxFileSize', {
              size: maxFileSizeMB,
            })
          "
          class="text"
        ></p>
        <div class="adjuntarButtonStyle">
          <input
            @change="onFileChange"
            ref="fileInput"
            type="file"
            id="file"
            class="file"
            multiple
          />
          <label for="file">
            <i class="pi pi-paperclip iconSize buttonIcon" />
            {{ this.$t("datos.label.adjuntarArchivos") }}
          </label>
        </div>
        <small v-if="!validation.files" class="p-invalid">{{
          this.$t("datos.messages.error.filesError", {
            size: maxFileSizeMB,
            current: totalFileSize,
          })
        }}</small>
        <div class="file-list">
          <div v-for="file in files" :key="file.filename">
            <span
              class="cursorPointer"
              @click="
                [
                  removeArrayElement(files, file),
                  removeArrayBeforeConversionElement(
                    filesBeforeConversion,
                    file
                  ),
                  resetInputFile(),
                ]
              "
            >
              <i class="pi pi-times iconSize buttonIcon" />
            </span>
            <span class="file-text">{{ file.filename }}</span>
          </div>
        </div>
      </div>
      <div class="marginBottom">
        <p v-html="this.$t('datos.label.ibanAcreedor')" class="bigBlueText"></p>
        <p v-html="this.$t('datos.textos.ibanAcreedor')" class="text"></p>
        <div class="grid">
          <div class="col-12 md:col-6">
            <InputText
              v-model="iban"
              :class="`input ${validation.iban === false && 'p-invalid'}`"
              id="iban"
              type="text"
              :placeholder="this.$t('datos.placeholders.iban')"
            />
          </div>
        </div>
      </div>

      <div>
        <p class="bigBlueText">{{ this.$t("datos.label.observaciones") }}</p>
        <Textarea
          v-model="datosDeuda.observaciones"
          class="input textbox"
          :placeholder="this.$t('datos.placeholders.observaciones')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IbanMixin from "@/utils/iban";
import { GET_DEBT_ORIGIN_LIST } from "@/graphQLQueries/OtrosQueries";
import FilesMixin from "@/utils/files";
import {
  MAX_FILE_SIZE_MB,
  MAX_FILE_SIZE_BYTES,
  MASK_IBAN,
} from "@/resources/constants";
import MessagesMixin from "@/utils/messages";
import Errors from "@/components/utilidades/Errors.vue";

const RECLAMACION_MINIMA = 50;

export default {
  name: "DatosDeuda",
  mixins: [FilesMixin, IbanMixin, MessagesMixin],
  props: {
    paid: {
      type: Boolean,
      required: true,
    },
    debtorData: {
      type: Object,
      required: true,
    },
    defaultLanguage: {
      type: Object,
      required: true,
    },
  },
  components: {
    Errors: Errors,
  },
  created() {
    this.maskIban = MASK_IBAN;
  },
  data() {
    return {
      errors: [],
      language: this.defaultLanguage,
      isPaid: this.paid,
      origenesDeuda: [],
      showAddDeuda: false,
      showEditDeuda: false,
      nuevoPago: {
        fecha: "",
        importe: "",
      },
      selectedDebt: {
        fecha: "",
        importe: "",
        pagos: [],
      },
      selectedDebtOldValue: {},
      datosDeuda: {
        impagos: [],
        origen: "",
        demanda: "noAccionLegal",
        observaciones: "",
        divisa: "EUR",
      },
      iban: "",
      files: [],
      filesBeforeConversion: [],
      validation: {
        deudaExpirada5Anios: true,
        deudaExpirada10Anios: true,
        debtOrigin: true,
        payments: true,
        files: true,
        lawsuit: true,
        iban: true,
        hayDeuda: true,
        totalReclamado: true,
      },
      maxFileSizeMB: MAX_FILE_SIZE_MB,
      totalFileSize: 0,
    };
  },
  methods: {
    // Deuda Expirada = Warning. Si no hay otra reclamacion = ERROR.

    rowClass(impago) {
      //Comprobacion deuda negativa
      const deuda =
        impago.importe -
        impago.pagos.reduce((c, d) => parseFloat(c) + parseFloat(d.importe), 0);
      const deudaNegativa = deuda < 0;

      var fechaVencimiento = new Date(impago.fechaVencimiento);
      //Comprobacion deuda expirada 5Anios
      var haceCincoAnios = new Date();
      haceCincoAnios.setFullYear(haceCincoAnios.getFullYear() - 5);

      const deudaExpirada5Anios =
        fechaVencimiento < haceCincoAnios &&
        (this.debtorData.tipoEntidad == "deudorParticular" ||
          this.debtorData.tipoEntidad == "deudorAutonomo");

      //Comprobacion deuda expirada 10Anios
      var haceDiezAnios = new Date();
      haceDiezAnios.setFullYear(haceDiezAnios.getFullYear() - 10);

      const deudaExpirada10Anios =
        fechaVencimiento < haceDiezAnios &&
        this.debtorData.tipoEntidad == "deudorEntidad";

      return deudaNegativa || deudaExpirada5Anios || deudaExpirada10Anios
        ? "altaDeudaError"
        : null;
    },
    hasFormErrors() {
      this.getErrorMessages();
      return !(
        this.validation.iban &&
        this.validation.debtOrigin &&
        this.validation.payments &&
        this.validation.lawsuit &&
        this.validation.deudaExpirada5Anios &&
        this.validation.deudaExpirada10Anios &&
        this.validation.hayDeuda &&
        this.validation.totalReclamado &&
        this.validation.files
      );
    },
    getErrorMessages() {
      if (!this.validation.iban){
        this.errors.push(this.$i18n.t("datos.messages.error.iban"));
      }
      if (!this.validation.debtOrigin){
        this.errors.push(this.$i18n.t("datos.messages.error.debtOrigin"));
      }
      if (!this.validation.files){
        this.errors.push(this.$i18n.t("datos.messages.error.files"));
      }

    },
    validateForm() {
      this.errors = [];
      this.validateDebts();
      this.isValidIBANNumber(this.iban)
        ? (this.validation.iban = true)
        : (this.validation.iban = false);
      this.validateFiles();
      this.validateLawSuit();
      this.validateDebtOrigin();
      this.validateDeudas();
    },
    validateDebtOrigin() {
      this.datosDeuda.origen
        ? (this.validation.debtOrigin = true)
        : (this.validation.debtOrigin = false);
    },
    validateLawSuit() {
      this.datosDeuda.demanda
        ? (this.validation.lawsuit = true)
        : (this.validation.lawsuit = false);
    },
    validateDebts() {
      this.datosDeuda.impagos.length > 0
        ? (this.validation.payments = true)
        : (this.validation.payments = false);
    },
    validateFiles() {
      const totalFileSizeBytes = this.filesBeforeConversion.reduce(
        (total, current) => total + current.size,
        0
      );

      this.totalFileSize =
        Math.round((totalFileSizeBytes / (1024 * 1024)) * 100) / 100;

      this.validation.files =
        this.filesBeforeConversion &&
        this.filesBeforeConversion.length > 0 &&
        totalFileSizeBytes <= MAX_FILE_SIZE_BYTES;
    },
    validateDeudas() {
      if (this.datosDeuda.impagos && this.datosDeuda.impagos.length > 0) {
        this.validation.hayDeuda = true;
        this.validation.totalReclamado = true;

        //5Anios
        if (
          this.debtorData.tipoEntidad == "deudorParticular" ||
          this.debtorData.tipoEntidad == "deudorAutonomo"
        ) {
          var haceCincoAnios = new Date();
          haceCincoAnios.setFullYear(haceCincoAnios.getFullYear() - 5);
          var result1 = this.datosDeuda.impagos.reduce((acc, impago) => {
            var fechaVencimiento = new Date(impago.fechaVencimiento);
            return fechaVencimiento < haceCincoAnios ? acc + 1 : acc;
          }, 0);

          if (result1 == 0) {
            this.validation.deudaExpirada5Anios = true;
          } else {
            this.validation.deudaExpirada5Anios = false;
            this.errors.push(
              this.$i18n.t("datos.messages.error.deudaFullExpirada5Anios")
            );
          }
        } else {
          this.validation.deudaExpirada5Anios = true;
        }

        //10Anios
        if (this.debtorData.tipoEntidad == "deudorEntidad") {
          var haceDiezAnios = new Date();
          haceDiezAnios.setFullYear(haceDiezAnios.getFullYear() - 10);
          var result2 = this.datosDeuda.impagos.reduce((acc, impago) => {
            var fechaVencimiento = new Date(impago.fechaVencimiento);
            return fechaVencimiento < haceDiezAnios ? acc + 1 : acc;
          }, 0);

          if (result2 == 0) {
            this.validation.deudaExpirada10Anios = true;
          } else {
            this.validation.deudaExpirada10Anios = false;
            this.errors.push(
              this.$i18n.t("datos.messages.error.deudaFullExpirada10Anios")
            );
          }
        } else {
          this.validation.deudaExpirada10Anios = true;
        }

        // El total reclamado debe ser mayor o igual que RECLAMACION_MINIMA
        if (this.totalReclamado < RECLAMACION_MINIMA) {
          this.errors.push(this.$i18n.t("datos.messages.error.totalReclamado"));
          this.validation.totalReclamado = false;
        }
      } else {
        this.errors.push(this.$i18n.t("datos.messages.error.noHayDeuda"));
        this.validation.hayDeuda = false;
      }
    },
    getImportePendiente(importe, pagos) {
      const importePendiente =
        parseFloat(importe) - this.getPagosRealizados(pagos);
      return !isNaN(importePendiente) ? importePendiente.toFixed(2) : 0;
    },
    getPagosRealizados(pagos) {
      const pagosRealizados = pagos.reduce(
        (a, b) => parseFloat(a) + parseFloat(b.importe),
        0
      );
      return !isNaN(pagosRealizados) ? pagosRealizados : 0;
    },
    async onFileChange(e) {
      const seen = new Set();
      let arrayFiles = this.filesBeforeConversion.concat(
        Array.from(e.target.files)
      );
      const filteredArr = arrayFiles.filter((el) => {
        const duplicate = seen.has(el.name);
        seen.add(el.name);
        return !duplicate;
      });
      this.filesBeforeConversion = filteredArr;
      this.files = await this.convertFiles(this.filesBeforeConversion);
    },
    handleAcceptDebt() {
      if (this.showAddDeuda) {
        this.addDeuda();
      }
      if (this.showEditDeuda) {
        this.showEditDeuda = false;
      }
      this.clearNuevaDeuda();
    },
    handleCancelDebt() {
      if (this.showAddDeuda) {
        this.showAddDeuda = false;
      }
      if (this.showEditDeuda) {
        this.selectedDebt.pagos = this.selectedDebtOldValue.pagos;
        this.selectedDebt.importe = this.selectedDebtOldValue.importe;
        this.selectedDebt.fechaVencimiento =
          this.selectedDebtOldValue.fechaVencimiento;
        this.showEditDeuda = false;
      }
    },
    addDeuda() {
      const impago = {
        fecha: "",
        fechaVencimiento: this.selectedDebt.fechaVencimiento,
        importe: this.selectedDebt.importe,
        referenciaCliente: "",
        pagos: this.selectedDebt.pagos,
      };

      this.datosDeuda.impagos.push(impago);
      this.showAddDeuda = false;
    },
    addNewPayment() {
      this.selectedDebt.pagos.push({
        importe: "",
        fecha: "",
      });
    },
    editDebt(debt) {
      this.selectedDebt = debt;
      this.selectedDebtOldValue = JSON.parse(JSON.stringify(this.selectedDebt));
      this.showEditDeuda = true;
    },
    removeArrayElement(list, value) {
      var idx = list.indexOf(value);

      if (idx !== -1) {
        list.splice(idx, 1);
      }
    },
    removeArrayBeforeConversionElement(list, value) {
      var listFiltered = list.filter((file) => file.name != value.filename);
      this.filesBeforeConversion = listFiltered;
    },
    resetInputFile() {
      this.$refs.fileInput.value = null;
    },
    clearNuevaDeuda() {
      this.selectedDebt = {
        fecha: "",
        importe: "",
        pagos: [],
      };
    },
    storeForm() {
      this.$store.dispatch("addDatosDeuda", this.datosDeuda);
    },
    isAcceptDebtButtonDisabled() {
      const hasPaymentsErrors = this.selectedDebt.pagos
        .map((p) => {
          const isAmountInvalid = isNaN(parseFloat(p.importe))
            ? true
            : parseFloat(p.importe) <= 0;
          const isDateInvalid = !p.fecha || p.fecha == "";
          return isAmountInvalid || isDateInvalid;
        })
        .some((i) => i);

      var isNegativo = false;
      if (!hasPaymentsErrors) {
        var deuda =
          parseFloat(this.selectedDebt.importe) -
          this.selectedDebt.pagos.reduce(
            (c, d) => parseFloat(c) + parseFloat(d.importe),
            0
          );
        isNegativo = deuda < 0;
      }

      return (
        this.selectedDebt.fechaVencimiento == "" ||
        !this.selectedDebt.fechaVencimiento ||
        !this.selectedDebt.importe ||
        this.selectedDebt.importe == "" ||
        hasPaymentsErrors ||
        isNegativo
      );
    },
    retrieveDebtOrigins() {
      this.$apollo
        .query({
          query: GET_DEBT_ORIGIN_LIST,
          variables: {
            idioma: this.defaultLanguage.language,
          },
        })
        .then((data) => {
          this.origenesDeuda = data.data.listadoOrigenesDeuda;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  watch: {
    paid(newValue) {
      this.isPaid = newValue;
    },
    language(newValue) {
      this.defaultLanguage = newValue;
    },
  },
  mounted() {
    this.bonoUsado = this.$route.params.bonoUsado
      ? this.$route.params.bonoUsado
      : undefined;
    if (this.bonoUsado) {
      this.setMessages(
        "success",
        this.$t("datos.messages.success.bonoUsado"),
        6000
      );
    }
    this.retrieveDebtOrigins();
  },
  computed: {
    totalReclamado() {
      const total = this.datosDeuda.impagos.reduce((a, b) => {
        var accum = parseFloat(a);
        var deuda =
          parseFloat(b.importe) -
          b.pagos.reduce((c, d) => parseFloat(c) + parseFloat(d.importe), 0);
        if (deuda < 0) {
          return accum;
        } else {
          return accum + deuda;
        }
      }, 0);
      return !isNaN(total) ? total.toFixed(2) : 0;
    },
    selectedDebtNegativa() {
      if (this.selectedDebt) {
        var sum = parseFloat(this.selectedDebt.importe);
        var resta = 0;
        if (this.selectedDebt.pagos) {
          resta = this.selectedDebt.pagos.reduce(
            (c, d) => parseFloat(c) + parseFloat(d.importe),
            0
          );
        }
        return sum - resta < 0;
      }
      return false;
    },
    errorDeudaExpirada5Anios() {
      //Comprobacion deuda expirada 5Anios
      var haceCincoAnios = new Date();
      haceCincoAnios.setFullYear(haceCincoAnios.getFullYear() - 5);
      var result = this.datosDeuda.impagos.reduce((acc, impago) => {
        var fechaVencimiento = new Date(impago.fechaVencimiento);
        return (
          acc ||
          (fechaVencimiento < haceCincoAnios &&
            (this.debtorData.tipoEntidad == "deudorParticular" ||
              this.debtorData.tipoEntidad == "deudorAutonomo"))
        );
      }, false);
      return result;
    },
    errorDeudaExpirada10Anios() {
      //Comprobacion deuda expirada 10Anios
      var haceDiezAnios = new Date();
      haceDiezAnios.setFullYear(haceDiezAnios.getFullYear() - 10);
      var result = this.datosDeuda.impagos.reduce((acc, impago) => {
        var fechaVencimiento = new Date(impago.fechaVencimiento);
        return (
          acc ||
          (fechaVencimiento < haceDiezAnios &&
            this.debtorData.tipoEntidad == "deudorEntidad")
        );
      }, false);
      return result;
    },
    demandaJudicial() {
      return this.datosDeuda.demanda != "noAccionLegal";
    },
    demandaJudicialFavorable() {
      return this.datosDeuda.demanda == "siAccionLegalFavorable";
    },
  },
};
</script>

<style scoped>
.titlesContainer {
  margin-bottom: 1.25em !important;
}
.ajusteNoP {
  margin-top: 1cm;
}
.ajusteMargin {
  margin-top: 0px;
  margin-left: 25px;
  font-size: 11px;
}

.marginBottomSmaller {
  margin-bottom: -30px;
}
.inputSmall {
  height: 1cm;
  width: 100%;
  border: 2px solid #2e9ece;
  font-size: 12px;
}
.blueSum {
  background-color: #2e9ece;
  padding: 8px 3% 8px 3%;
  margin: 4px -1px 4px -1px;
  border: 1px solid #d0e1f2;
}
.centerDashedBlueSquare {
  border: 2px dashed #2e9ece;
  text-align: center;
  padding: 0px 3% 0px 3%;
  margin: 4px -1px 4px -1px;
}
.acceptButton {
  border-color: #2e9ece;
  background-color: #2e9ece;
  font-size: 12px;
  width: 2.5cm;
  border-radius: 4px;
  color: white;
}
.cancelButton {
  border-color: #7f7f7f;
  background-color: #7f7f7f;
  font-size: 12px;
  width: 2.5cm;
  border-radius: 4px;
  color: white;
}

.textbox {
  height: 3cm;
}
.adjuntarButtonStyle {
  width: 5.5cm;
  border-color: #2e9ece;
  background-color: #2e9ece;
  font-size: 14px;
  border-radius: 8px;
}
.adjuntarButtonStyle :hover {
  background-color: #2d728f;
}
.file {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}
.adjuntarButtonStyle label {
  display: block;
  position: relative;
  border-radius: 8px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  text-transform: uppercase;
  transition: transform 0.2s ease-out;
}
.buttonIcon {
  margin-right: 0.25em;
}
.marginBTdecreased {
  margin-top: -10px;
  margin-bottom: -20px;
}
.iconSize {
  font-size: 0.6cm;
}
.p-datatable-responsive-demo .p-datatable-tbody > tr > td .column-title {
  display: none;
}
.file-list {
  margin-top: 1em;
}
.file-list span {
  vertical-align: top;
}

.file-list .file-text {
  vertical-align: middle;
}

.cursorPointer:hover {
  cursor: pointer;
}
</style>
